import React, { useState, useEffect, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Menu from "@material-ui/core/Menu";
import { withStyles } from "@material-ui/core/styles";
import Sidebar from "../../common/sidebar/Sidebar";
import MenuItem from "@material-ui/core/MenuItem";
import { getUserData } from "../../common/utility/Utils";
import { HOST_URL, LOCAL_STORAGE_KEY, basename } from "../../../config";
import { StoreContext } from "../../../store/Provider";
import MenuIcon from "@material-ui/icons/Menu";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import "./home.css";
import axios from "axios";
import Shipments from "../shipments/Shipments";
import routeConstant from "./../../../route/compoent/routeConstant";
import MainLayout from "../../../order_managment/common/layout/MainLayout";

const StyledMenu = withStyles({
  paper: {
    border: "1px solid #d3d4d5",
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "center",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "center",
    }}
    {...props}
  />
));

function Home(props) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [outstandingData, setOutstandingData] = useState({});
  const context = useContext(StoreContext);
  const location = useLocation();
  const navigate = useNavigate();
  const [viewName, setViewName] = React.useState("");
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const logOut = () => {
    handleClose();
    localStorage.clear();
    window.location.reload(false);
  };

  const updatePassword = () => {
    handleClose();
    navigate(routeConstant.UPDATE_PASSWORD);
  };

  useEffect(() => {
    outstandingSummary();
  }, []);

  const outstandingSummary = async () => {
    let data = {};
    await getUserData(LOCAL_STORAGE_KEY.user_token)
      .then((res) => {
        data = res;
      })
      .catch((err) => {
        console.log(err);
      });
    const URL = `${HOST_URL}api/v2/OutStandingData/OutStandingSummary/${data.user_company_code}`;
    const header = {
      Authorization: `Bearer ${data.access_token}`,
      UserName: data.user_name,
      UserSecret: data.password,
      DeviceType: "W",
      MacAddress: "",
      IPAddress: "",
    };
    axios
      .get(URL, {
        headers: header,
      })
      .then((res) => {
        setOutstandingData(res.data);
      })
      .catch((res) => {
        console.log(res);
      });
  };

  const onSearchInputValueChange = (e) => {
    context.setSearchInputValue(e.target.value);
    // console.log(e)
  };

  const onSearchKeyDown = (e) => {
    const value = context.searchInputValue.trim();
    if (value !== "" && e.code === "Enter") {
      context.setShipmentId("");
      context.setSearchResultView(true);
    }
  };

  const onSearchIconClick = () => {
    context.setShipmentId("");
    context.setSearchResultView(true);
  };

  const onClearSearchInputValue = (e) => {
    context.setSearchInputValue("");
    context.setSearchResultView(false);
    context.setShipmentId("");
  };
  useEffect(() => {
    let data = JSON.parse(localStorage.getItem("UserDataLogin"));
    // console.log(data, "datatatatatat", context?.omsUserData);
    if (data != null) {
      setViewName(data?.user_fullname);
      // let decoded = jwt_decode(data?.access_token);
      // let objKeys = Object.keys (decoded)
      // let retKey = objKeys.filter((item)=>{
      //   return item.includes("name")
      // })
      // setViewName(decoded[retKey[0]])
    }

    // console.log(decoded[retKey[0]],"dataaaaaa");
  }, [context]);
  return (
    <>
      {context.isUserLogin ? (
        <header>
          <nav className="navbar navbar-expand-lg">
            <div className="container-fluid">
              <button
                className="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarScroll"
                aria-controls="navbarScroll"
                onClick={() => context.setSidebarOpen((prev) => !prev)}
              >
                <MenuIcon
                  className={
                    context.closeSidebar
                      ? "pointer toggleSidebar flip"
                      : "pointer toggleSidebar"
                  }
                />
              </button>
              <div className="collapse navbar-collapse">
                <MenuIcon
                  className={
                    context.closeSidebar
                      ? "pointer toggleSidebar flip"
                      : "pointer toggleSidebar"
                  }
                  onClick={() => context.setSidebarOpen((prev) => !prev)}
                />
                <div className="headergreet ms-3">
                  {location.pathname.includes(routeConstant.SHIPMENT) && (
                    <div className="headersearch">
                      <input
                        type="text"
                        className="form-control"
                        value={context.searchInputValue}
                        id="headersearch"
                        placeholder="Search for your shipments"
                        onChange={onSearchInputValueChange}
                        onKeyPress={onSearchKeyDown}
                      />
                      {context.searchInputValue === "" ? (
                        ""
                      ) : (
                        <img
                          src={`/${basename}/Assets/Images/close.svg`}
                          className="closeSearch"
                          alt="search"
                          onClick={onClearSearchInputValue}
                        />
                      )}
                      <img
                        src={`/${basename}/Assets/Images/searchIcon.svg`}
                        alt="search"
                        onClick={onSearchIconClick}
                      />
                    </div>
                  )}
                  {location.pathname.includes(routeConstant.DASHBOARD) ? (
                    <div className="invoiceAMTparent">
                      {outstandingData.OutstandingAmount ? (
                        <div className="outAmtdata mx-3">
                          <span>Outstanding Amount</span>
                          <p>
                            $
                            {context.calculateAmmount(
                              outstandingData.OutstandingAmount
                            )}
                          </p>
                        </div>
                      ) : null}
                      {outstandingData.TotalInvoice ? (
                        <div className="outAmtdata mx-3">
                          <span>Total Invoice</span>
                          <p>{outstandingData.TotalInvoice}</p>
                        </div>
                      ) : null}
                    </div>
                  ) : null}
                </div>
                <div className="d-flex ms-auto">
                  <ul className="navbar-nav mb-2 mb-lg-0">
                    <li>
                      <div className="headersearchUser nameid">
                        <span
                          style={{
                            color: "#fff",
                            cursor: "default",
                            display: "none",
                          }}
                        >
                          {location.pathname.includes(
                            routeConstant.ORDER_MAIN
                          ) ? (
                            context.omsUserData?.UserRoles ? (
                              <>({context.omsUserData?.UserRoles})</>
                            ) : (
                              ""
                            )
                          ) : null}
                        </span>
                        {viewName}
                        {/* {context.omsUserData?.FullName?.split(" ")[0]
                          ? context.omsUserData?.FullName?.split(" ")[0]
                          : ""} */}
                        <span>
                          <AccountCircleIcon onClick={handleClick} />
                        </span>
                      </div>
                    </li>
                  </ul>
                </div>
                <StyledMenu
                  id="mailMenu"
                  anchorEl={anchorEl}
                  keepMounted
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                >
                  <MenuItem>{context.omsUserData?.OrgCodes}</MenuItem>
                  <MenuItem
                    onClick={() => {
                      navigate(routeConstant.PROFILE);
                      handleClose();
                    }}
                  >
                    Profile
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      navigate(routeConstant.CHANGEPASSWORD);
                      handleClose();
                    }}
                  >
                    Change Password
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      context.setNotificationOpen({
                        open: true,
                        type: "Notification",
                        reload: false,
                      });
                      handleClose();
                    }}
                  >
                    Notification Settings
                  </MenuItem>
                  {/* <MenuItem onClick={updatePassword}>Update Password</MenuItem> */}
                  <MenuItem onClick={logOut}>Log Out</MenuItem>
                </StyledMenu>
              </div>
            </div>
          </nav>
        </header>
      ) : null}
      <Shipments />
    </>
  );
}

export default Home;
